import React, { Component, createElement, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import FocusTrap from '@checkout-s/FocusTrap';
import { getInitialFocusSelector } from '../../../helpers/helpers';
import { selectEventNameFromListingConfig } from 'checkout/selectors/ui';
import { TranslationContext } from '@checkout-c/Translations';
import clsx from 'clsx';

const initialFocusSelectors = [
  '.ticket-action__add-button',
  '.collapsible__button',
  '.add-to-cart__button',
  '.input__control[name=section]'
].join(', ');

class TicketPickerContainer extends Component {
    scrollToTop = () => {
        window.scrollTo(0,0);
    }
  
    componentDidMount = () => {
        this.scrollToTop();
    }

    onAnimationEnd = (event) => {
      if (event.target.className.includes('ticket-action__quantity')) {
        return;
      }

      this.scrollToTop();
    }

    getContent = (t) => {
        const parentElement = this.props.inline ? 'div' : 'dialog';

        const dialogProps = {
          "aria-modal": true,
          "tabIndex": "-1",
        }

        const className = clsx(
          'tickets-wrap',
          this.props.inline ? 'tickets--inline' : 'tickets--as-overlay',
          {
            'tickets-wrap--seating-chart': this.props.isSeatingChart,
          }
        )
      
        return createElement(parentElement, {
          className: `tickets--as-overlay ${className}`,
          "aria-label": t('checkout__tickets_for_event', { event_name: this.props.eventName }),
          ...(!this.props.inline ? dialogProps : {}),
        }, (
          <div className={clsx("tickets", this.props.inline && "tickets--no-animation")} onAnimationEnd={this.onAnimationEnd}>
            {this.props.children}
          </div>
        ))
    };

    render() {
        return(
          <TranslationContext.Consumer>
            {({ t }) => (
              <Fragment>
                {!this.props.focusTrap && this.getContent(t)}
                {this.props.focusTrap && (
                  <FocusTrap
                      id="ticket-picker"
                      active={!this.props.inline}
                      fallback=".ticket__hide-overlay, .button"
                      focusTrapOptions={{
                          initialFocus: getInitialFocusSelector(initialFocusSelectors),
                      }}

                  >
                      {this.getContent(t)}
                  </FocusTrap>
                )}
              </Fragment>
            )}
          </TranslationContext.Consumer>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
        eventName: selectEventNameFromListingConfig(state),
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
    }, dispatch);
}

TicketPickerContainer.propTypes = {
    focusTrap: PropTypes.bool,
}

TicketPickerContainer.defaultProps = {
    focusTrap: true,
}

export default connect(mapStateToProps, mapDispatchToProps)(TicketPickerContainer)
